'use client';
// footer、選單 語言切換
import { useParams } from 'next/navigation';
import { useDispatch } from 'react-redux';
import { setShowLanguageModal } from '@/slices/popSlice';
import Image from 'next/image';

const FooterToggleLanguage = ({ position }) => {
    const dispatch = useDispatch();
    const params = useParams();
    const { locale } = params;

    return (
        <button
            className={`center-center px-[20px] py-[14px] text-btn1 mx-auto
                ${position === 'menu' ? 'hidden ulg:flex mt-[24px] text-black9' : 'text-white'}`}
            onClick={() => dispatch(setShowLanguageModal(true))}
        >
            <Image
                width={16}
                height={16}
                src="/images/icon/icon_language.svg"
                alt="icon"
                className={`filter-white ${position === 'menu' ? 'filter-black7' : ''}`}
            />
            <span className="ml-[10px] mr-[14px]">{locale === 'tw' ? '繁體中文' : '简体中文'}</span>

            <Image
                width={12}
                height={12}
                className={position === 'menu' ? 'filter-black7' : ''}
                src="/images/icon/icon_down_arrow.svg"
                alt="icon"
            />
        </button>
    );
};

export default FooterToggleLanguage;
